import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  dialog: {
    '&&&': {
      zIndex: 2000,
    },
  },
}));
